import { css, StyleDeclarationValue } from 'aphrodite';
import * as React from 'react';
import { getDisplayName } from '../../../../models/NameUtils';
import { useFullscreenModal } from '../../../../models/hooks/appStateHooks';
import { MultiContainerHeader } from '../../../../web/components/MultiContainerHeader';
import { YouDidItGraphic } from '../../../../web/components/svgs/graphics/YouDidItGraphic';
import { BlogPostContext } from '../../../../web/containers/blogs/blogPostContext';
import { baseStyleSheet } from '../../../../web/styles/styles';
import { styleSheet } from './styles';

interface IProps {
	className?: string;
	customMessaging?: string;
	multiple?: boolean;
	styles?: StyleDeclarationValue[];
}

export function AccountContentCalendarBlogScheduleSuccess({ className, styles, customMessaging, multiple }: IProps) {
	const fullscreenModal = useFullscreenModal();
	const { blogPost } = React.useContext(BlogPostContext) || {};
	const approval = blogPost?.approvalRequests?.[0];
	const approverName = getDisplayName(approval?.approver) || 'the approver';
	return (
		<div
			className={`${css(styleSheet.container, ...(styles || []))} bulk-blog-approval-confirmation ${className || ''}`}
		>
			<MultiContainerHeader
				fullscreenHeader={`Schedule Blog${multiple ? 's' : ''}: Completed`}
				onFullscreenRequestBack={e => {
					e.preventDefault();
					fullscreenModal.dismissModal();
				}}
				onFullscreenRequestClose={ev => {
					ev.preventDefault();
					fullscreenModal.dismissModal();
				}}
			/>
			<div className={css(styleSheet.content)}>
				<YouDidItGraphic />
				<div className={css(styleSheet.title)}>Hey boo, you did it.</div>
				{customMessaging ? (
					<div className={css(styleSheet.message)}>{customMessaging}</div>
				) : (
					<>
						<div
							className={css(styleSheet.message)}
						>{`${approval?.approver?.firstName ?? approverName} will be notified via email.`}</div>
						<div className={css(styleSheet.message)}>
							{`You can check back in to see if ${approverName} has approved the post${multiple ? 's' : ''}.`}
						</div>
					</>
				)}
				<button
					className={css(baseStyleSheet.ctaButton, styleSheet.button)}
					onClick={() => fullscreenModal.dismissModal()}
				>
					<span>Close window</span>
				</button>
			</div>
		</div>
	);
}
